<template>
  <div class="mg-t-20">
    <div
      v-if="tiltleTableFormReport.length !== 0 && tableDataValue.length != 0"
      class="is-flex is-justify-spacebetween is-align-center"
    >
      <p></p>
      <div class="is-flex">
        <a class="mg-5" @click="csvExport(csvData)"
          ><i class="fas fa-lg fa-download"></i>
          {{ $t("form.formExportButton") }}</a
        >
        <a @click="isListCheckTitle = true" class="mg-5"
          ><i class="fas fa-lg fa-cog"></i>
          {{ $t("form.formSettingButton") }}</a
        >
      </div>
    </div>
    <div
      v-if="tiltleTableFormReport.length === 0 || tableDataValue.length === 0"
      class="is-align-center is-justify-center is-flex is-flex-row m-h-auto"
    >
      <p class="has-text-grey is-size-4 th is-padding-x-s is-margin-top-s">
        ***
      </p>
      <p class="has-text-grey is-size-6 th is-padding-x has-text-centered">
        {{ $t("form.notFoundFormData") }}
      </p>
      <p class="has-text-grey is-size-4 th is-padding-x-s is-margin-top-s">
        ***
      </p>
    </div>
    <section v-else>
      <b-table
        :data="tableData"
        :bordered="true"
        :hoverable="true"
        class="th has-text-weight-normal header-titile"
      >
        <template slot-scope="props">
          <b-table-column
            v-for="(column, index) in columnsTemplate"
            :key="index"
            :label="column.title + ' (' + index + ')'"
            :visible="column.visible"
          >
            <div
              class="th"
              v-if="
                typeof props.row[column.field] !== 'undefined' &&
                props.row[column.field] !== null &&
                props.row[column.field] !== '' &&
                props.row[column.field].length !== 0
              "
            >
              <p v-if="column.type === 'date'">
                {{ dateFomat(props.row[column.field]) }}
              </p>
              <p v-else-if="column.type === 'radio'">
                <span v-if="props.row[column.field].data !== null">
                  <span v-if="props.row[column.field].data.userValue === true">
                    {{ props.row[column.field].des }}
                  </span>
                  <span v-else>
                    {{ props.row[column.field].data.label }}
                  </span>
                </span>
                <i v-else>{{ $t("form.notFoundFormData") }}</i>
              </p>
              <p v-else-if="column.type === 'select'">
                <span
                  v-if="
                    typeof props.row[column.field].phoneNumber !== 'undefined'
                  "
                  >{{ props.row[column.field].formatInternational }}</span
                >
                <span v-else>{{ props.row[column.field].label }}</span>
              </p>
              <div v-else-if="column.type === 'file'">
                <p
                  v-if="typeof props.row[column.field][0] === 'undefined'"
                  :key="fileIndex"
                >
                  {{ props.row[column.field].name }}
                </p>
                <div v-else>
                  <p
                    v-for="(file, fileIndex) in props.row[column.field]"
                    :key="fileIndex"
                  >
                    {{ fileIndex + 1 }}. {{ file.name }}
                  </p>
                </div>
              </div>
              <div v-else-if="column.type === 'checkbox'">
                <p
                  v-for="(file, fileIndex) in props.row[column.field]"
                  :key="fileIndex"
                >
                  <span
                    v-if="
                      typeof file.userValue === 'undefined' ||
                      file.userValue === false
                    "
                    >{{ fileIndex + 1 }}. {{ file.label }}</span
                  >
                  <span v-else>{{ fileIndex + 1 }}. {{ file.des }}</span>
                </p>
              </div>
              <p v-else>{{ props.row[column.field] }}</p>
            </div>
            <i v-else>{{ $t("form.notFoundFormData") }}</i>
          </b-table-column>
        </template>
      </b-table>
    </section>

    <b-modal :active.sync="isListCheckTitle" :width="900" @close="setCsvJson()">
      <div class="card modalActivity">
        <div class="card-content">
          <div class="content">
            <div>
              <p class="is-size-3 th has-text-centered">
                {{ $t("form.formSettingDetailHeader") }}
              </p>
              <p class="is-size-5 th has-text-centered">
                ({{ $t("form.formSettingDetailSubHeader") }})
              </p>
            </div>
            <div class="has-text-centered">
              <button
                class="button field has-bg-primary has-text-white mg-10"
                @click="checkAll()"
                :disabled="false"
              >
                <b-icon pack="fas" icon="check"></b-icon>
                <span>{{ $t("form.formSettingDetailCheck") }}</span>
              </button>
              <button
                class="button field has-bg-danger has-text-white mg-10"
                @click="clearAll()"
                :disabled="false"
              >
                <b-icon pack="fas" icon="times"></b-icon>
                <span>{{ $t("form.formSettingDetailClear") }}</span>
              </button>
            </div>
            <div class="th pd-y-10">
              <div
                v-for="(column, index) in columnsTemplateTitle"
                :key="index"
                class="has-text-left pd-l-20 pd-y-5"
              >
                <b-checkbox v-model="column.visible">
                  {{ column.title + " (" + (index + 1) + ")" }}
                </b-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { HTTP, HTTPDynamic } from "../../axios";

export default {
  name: "ComponentReport",
  props: ["tiltleTableFormReport", "tableDataValue", "inputFormComponent"],
  data() {
    return {
      tableData: [],
      columnsTemplate: [],
      isListCheckTitle: false,
      jsonData: [],
      dataFile: "",
      labels: {},
      isExported: false,
      csvData: [],
      urlFile: process.env.VUE_APP_URL_DYNAMIC,
    };
  },
  mounted() {
    this.columnsTemplate = this.tiltleTableFormReport;
    this.tableData = this.tableDataValue;
    setTimeout(() => {
      this.setCsvJson();
    }, 1000);
  },
  watch: {
    // tableDataValue(){
    //         this.setCsvJson()
    // }
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    columnsTemplateTitle() {
      let data = this.columnsTemplate.filter(
        (item) => item.field !== "company"
      );
      return data;
    },
  },
  methods: {
    csvExport(arrData) {
      let title = [];
      for (let index = 0; index < this.columnsTemplate.length; index++) {
        if (this.columnsTemplate[index].visible === true) {
          title.push(this.columnsTemplate[index].title);
        }
      }

      let csvContent = "";
      csvContent += [
        title.join(","),
        ...arrData.map((item) => Object.values(item).join(",")),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      var link = window.document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent)
      );
      link.setAttribute("download", this.dataFile + ".csv");
      link.click();
    },
    csvExportXls() {
      let dt = new Date();
      let day = dt.getDate();
      let month = dt.getMonth() + 1;
      let year = dt.getFullYear();
      let hour = dt.getHours();
      let mins = dt.getMinutes();
      let postfix = day + "." + month + "." + year + "_" + hour + "." + mins;

      let link = window.document.createElement("a");
      let data_type = "data:application/vnd.ms-excel;charset=utf-8";
      let table_html =
        window.document.getElementsByTagName("table")[0].outerHTML;
      table_html = table_html.replace(/<tfoot[\s\S.]*tfoot>/gim, "");
      let css_html =
        "<style>table { border: 0.5pt solid #c0c0c0 } td {border: 0.5pt solid #c0c0c0;vertical-align:middle;} .tRight { text-align:right} .tLeft { text-align:left} </style>";
      let encodeURI =
        data_type +
        "," +
        encodeURIComponent(
          "<html><head>" +
            css_html +
            "</" +
            "head><body>" +
            table_html +
            "</body></html>"
        );

      link.setAttribute("href", encodeURI);
      link.setAttribute("download", this.dataFile + ".xls");
      link.click();
    },
    dateFomat(date) {
      let arr = date.split("/");
      let res = "";
      arr.map((item, index) => {
        if (typeof date === "undefined" || date === null || date === "") {
          res = "-";
        } else {
          res +=
            (index === 0 ? "" : "/") + this.$moment(item).format("DD-MM-YYYY");
        }
      });

      return res;
    },
    checkAll() {
      this.columnsTemplate.map((item) => {
        if (item.field !== "company") {
          item.visible = true;
        }
      });
    },
    clearAll() {
      this.columnsTemplate.map((item) => {
        if (item.field !== "company") {
          item.visible = false;
        }
      });
    },
    setCsvJson() {
      this.csvData = [];
      let obj = {};
      let label = {};

      for (let x = 0; x < this.tableDataValue.length; x++) {
        for (let y = 0; y < this.columnsTemplate.length; y++) {
          if (this.columnsTemplate[y].visible === true) {
            if (this.columnsTemplate[y].type === "date") {
              obj[this.columnsTemplate[y].field] =
                typeof this.tableDataValue[x][this.columnsTemplate[y].field] !==
                  "undefined" &&
                this.tableDataValue[x][this.columnsTemplate[y].field] !== null
                  ? '"' +
                    this.dateFomat(
                      this.tableDataValue[x][this.columnsTemplate[y].field]
                    ) +
                    '"'
                  : null;
            } else if (this.columnsTemplate[y].type === "select") {
              if (
                typeof this.tableDataValue[x][this.columnsTemplate[y].field] !==
                  "undefined" &&
                this.tableDataValue[x][this.columnsTemplate[y].field] !== null
              ) {
                obj[this.columnsTemplate[y].field] =
                  typeof this.tableDataValue[x][this.columnsTemplate[y].field]
                    .phoneNumber !== "undefined"
                    ? '"' +
                      this.tableDataValue[x][this.columnsTemplate[y].field]
                        .phoneNumber +
                      '"'
                    : '"' +
                      this.tableDataValue[x][this.columnsTemplate[y].field]
                        .label +
                      '"';
              } else {
                obj[this.columnsTemplate[y].field] = null;
              }
            } else if (this.columnsTemplate[y].type === "radio") {
              if (
                typeof this.tableDataValue[x][this.columnsTemplate[y].field] !==
                  "undefined" &&
                this.tableDataValue[x][this.columnsTemplate[y].field] !==
                  null &&
                this.tableDataValue[x][this.columnsTemplate[y].field].data !==
                  null
              ) {
                obj[this.columnsTemplate[y].field] =
                  typeof this.tableDataValue[x][this.columnsTemplate[y].field]
                    .data !== "undefined" &&
                  this.tableDataValue[x][this.columnsTemplate[y].field].data
                    .userValue === true
                    ? '"' +
                      this.tableDataValue[x][this.columnsTemplate[y].field]
                        .des +
                      '"'
                    : '"' +
                      this.tableDataValue[x][this.columnsTemplate[y].field].data
                        .label +
                      '"';
              } else {
                obj[this.columnsTemplate[y].field] = null;
              }
            } else if (this.columnsTemplate[y].type === "file") {
              if (
                typeof this.tableDataValue[x][this.columnsTemplate[y].field] !==
                "undefined"
              ) {
                let str = "";
                if (
                  this.tableDataValue[x][this.columnsTemplate[y].field] !== null
                ) {
                  if (
                    typeof this.tableDataValue[x][
                      this.columnsTemplate[y].field
                    ][0] === "undefined"
                  ) {
                    if (
                      typeof this.tableDataValue[x][
                        this.columnsTemplate[y].field
                      ].name !== "undefined"
                    ) {
                      str =
                        '=HYPERLINK("' +
                        this.urlFile +
                        this.tableDataValue[x].companyId +
                        "/" +
                        this.tableDataValue[x][this.columnsTemplate[y].field]
                          .name +
                        '")';
                    } else {
                      str = "";
                    }
                  } else {
                    for (
                      let index = 0;
                      index <
                      this.tableDataValue[x][this.columnsTemplate[y].field]
                        .length;
                      index++
                    ) {
                      let text =
                        this.urlFile +
                        this.tableDataValue[x].companyId +
                        "/" +
                        this.tableDataValue[x][this.columnsTemplate[y].field][
                          index
                        ].name +
                        ", ";
                      str += text;
                    }
                    str = '"' + str + '"';
                  }
                }

                obj[this.columnsTemplate[y].field] = str;
              } else {
                obj[this.columnsTemplate[y].field] = null;
              }
            } else if (this.columnsTemplate[y].type === "checkbox") {
              if (
                typeof this.tableDataValue[x][this.columnsTemplate[y].field] !==
                "undefined"
              ) {
                let str = "";
                for (
                  let index = 0;
                  index <
                  this.tableDataValue[x][this.columnsTemplate[y].field].length;
                  index++
                ) {
                  let text = "";
                  if (
                    typeof this.tableDataValue[x][
                      this.columnsTemplate[y].field
                    ][index].userValue === "undefined" ||
                    this.tableDataValue[x][this.columnsTemplate[y].field][index]
                      .userValue === false
                  ) {
                    text =
                      index +
                      1 +
                      ". " +
                      this.tableDataValue[x][this.columnsTemplate[y].field][
                        index
                      ].label +
                      " ";
                  } else {
                    text =
                      index +
                      1 +
                      ". " +
                      this.tableDataValue[x][this.columnsTemplate[y].field][
                        index
                      ].des +
                      " ";
                  }

                  str += text;
                }

                obj[this.columnsTemplate[y].field] = '"' + str + '"';
              } else {
                obj[this.columnsTemplate[y].field] = null;
              }
            } else {
              obj[this.columnsTemplate[y].field] =
                typeof this.tableDataValue[x][this.columnsTemplate[y].field] !==
                  "undefined" &&
                this.tableDataValue[x][this.columnsTemplate[y].field] !== null
                  ? '"' +
                    this.tableDataValue[x][
                      this.columnsTemplate[y].field
                    ].replace(/#|,|-|\n/g, "") +
                    '"'
                  : null;
            }
          }
        }

        this.csvData.push(obj);

        obj = {};
      }

      this.labels = label;
      this.dataFile =
        "Report_" +
        new Date().getDate() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getFullYear() +
        "_" +
        new Date().getHours() +
        "-" +
        new Date().getMinutes() +
        "-" +
        new Date().getSeconds();
    },
  },
};
</script>
<style scoped>
section {
  overflow-x: auto !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.b-table .table th {
  font-weight: 400 !important;
}
.b-table .table {
  border-radius: 0px !important;
}
i {
  color: #ccc;
  font-weight: 200;
}
th {
  font-weight: 500 !important;
}
td {
  min-width: 100px !important;
}
a {
  color: #6d8df3;
}
.mg-t-empty {
  margin-top: 150px !important;
}
</style>
